window.kgToggleVariantMediaGallery = () => {
  const kgProductForm = document.querySelector("form.product-form");
  if (!kgProductForm) return;
  const kgCurrentVariantId = kgProductForm.querySelector('input[name="id"]').value; 
  const kgToggleVariantMediaGallery = document.querySelectorAll(
    "media-gallery.media-gallery"
  );
  
  if (kgToggleVariantMediaGallery.length === 0) return;
  const kgDefaultVariantMediaGallery = document.querySelector("media-gallery.media-gallery:not([data-kg-variant-id])");
  const kgToggleVariantMediaGalleryItem = document.querySelector(`media-gallery.media-gallery[data-kg-variant-id="${kgCurrentVariantId}"]`);

  kgToggleVariantMediaGallery.forEach((kgToggleVariantMediaGalleryItem) => {
    kgToggleVariantMediaGalleryItem.style.display = "none";
  });

  if (kgToggleVariantMediaGalleryItem) {
    if (!kgDefaultVariantMediaGallery) return;
    kgToggleVariantMediaGalleryItem.style.display = "block";
  } else {
    if (!kgDefaultVariantMediaGallery) return;
    kgDefaultVariantMediaGallery.style.display = "block";
  }
};

document.addEventListener("DOMContentLoaded", () => { 
  if (typeof window.kgToggleVariantMediaGallery === "function") {
    kgToggleVariantMediaGallery();
  }
});
